import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="pursuitsFile";

export function selectByPursuitsId(PursuitsId){
  return axios({
    url: `/ws/${moduleName}/selectByPursuitsId/${PursuitsId}`,
    method: 'get',
  })
}

export function batchInsertPursuitsFiles(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/batchInsert`,
    method: 'post',
    data:parameter
  })
}


export function deleteFile(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    data:parameter
  })
}

export default {
  selectByPursuitsId,
  batchInsertPursuitsFiles,
  deleteFile,
}